import { ResourceName } from "../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../core/service/baseApi";
import type { LoadContractsAppProfilesRequest, SearchContractsAppProfilesTableResponse } from "./types";

export const contractsAcceptedCardProfilesApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadAcceptedCardProfiles: builder.query<SearchContractsAppProfilesTableResponse, LoadContractsAppProfilesRequest>({
            providesTags: ["mainCache"],
            query: ({ siteParams, dataGroupCode, queryParams }) => ({
                url: `${ResourceName.DATA_GROUPS}/${dataGroupCode}/${ResourceName.CONTRACTS}/${siteParams}accepted-card-profiles${queryParams}`,
                method: "GET",
            }),
        }),
        loadAcceptedCardProfilesVirtual: builder.query<SearchContractsAppProfilesTableResponse, LoadContractsAppProfilesRequest>({
            providesTags: ["mainCache"],
            query: ({ siteParams, dataGroupCode, queryParams }) => ({
                url: `${ResourceName.DATA_GROUPS}/${dataGroupCode}/${ResourceName.CONTRACTS}/${siteParams}accepted-card-profiles-virtual${queryParams}`,
                method: "GET",
            }),
        }),
        loadPhysicalAppProfilesVirtual: builder.query<SearchContractsAppProfilesTableResponse, LoadContractsAppProfilesRequest>({
            providesTags: ["mainCache"],
            query: ({ siteParams, dataGroupCode, queryParams }) => ({
                url: `${ResourceName.DATA_GROUPS}/${dataGroupCode}/${ResourceName.CONTRACTS}/${siteParams}physical-app-profiles-virtual${queryParams}`,
                method: "GET",
            }),
        }),
    }),
});

export const {
    useLazyLoadAcceptedCardProfilesQuery,
    useLazyLoadAcceptedCardProfilesVirtualQuery,
    useLazyLoadPhysicalAppProfilesVirtualQuery,
} = contractsAcceptedCardProfilesApi;
